import Meeting from "../types/models/Meeting";
import MeetingActionTypes from "../types/actions/MeetingAction";

const meetingDefaultState: Meeting = {
  meeting: {
    id: "",
    subEventId: "", // 서브이벤트
    applicant: "", // 신청자(application id)
    acceptor: "", // 수락자(application id)
    applicantName: "", // 신청기업
    acceptorName: "", // 수락기업
    meetingId: "", // 미팅시간 key
    status: "waiting", // 상태
    createdDate: "",
    modifiedDate: "",
    applicationFormAnswers: [], // 자유양식 답변(기업 기본정보)
  },
  meetings: [],
  meetingTargets: [],
  waitingAcceptMeetingTargets: [],
  meetingVideo: undefined,
  counselMeetings: [],
};

const meetingReducer = (
  state = meetingDefaultState,
  action: MeetingActionTypes
): Meeting => {
  switch (action.type) {
    case "CREATE_MEETING":
    case "GET_MEETING":
      return { ...state, meeting: action.meeting };
    case "GET_WAITING_ACCEPT_MEETING_TARGETS":
      return {
        ...state,
        waitingAcceptMeetingTargets: action.waitingAcceptMeetingTargets,
      };
    case "WAITING_ACCEPT_MEETING_TARGETS_RESET":
      return { ...state, waitingAcceptMeetingTargets: [] };
    case "GET_MEETING_TARGETS":
      return { ...state, meetingTargets: action.meetingTargets };
    case "MEETING_TARGETS_RESET":
      return { ...state, meetingTargets: [] };
    case "MEETINGS_RESET":
      return { ...state, meetings: [] };
    case "MEETING_RESET":
      return { ...state, meeting: meetingDefaultState.meeting };
    case "GET_MEETINGS":
      return { ...state, meetings: action.meetings };
    case "SET_MEETING_VIDEO":
      return { ...state, meetingVideo: action.meetingVideo };
    case "GET_MEETING_COUNSEL_LIST":
      return { ...state, counselMeetings: action.meetings };
    case "UPDATE_ACCEPTOR_MEEETING_SURVEY":
      state.meeting!.acceptorMeetingSurvey = [];
      return {
        ...state,
        meeting: {
          ...state.meeting,
          acceptorMeetingSurvey: action.meetingSurvey,
        },
      };
    case "UPDATE_APPLICANT_MEEETING_SURVEY":
      state.meeting!.applicantMeetingSurvey = [];
      return {
        ...state,
        meeting: {
          ...state.meeting,
          applicantMeetingSurvey: action.meetingSurvey,
        },
      };
    case "MEETING_STATE_RESET":
      return {
        ...meetingDefaultState,
        meetingVideo: state.meetingVideo,
      };

    default:
      return state;
  }
};

export default meetingReducer;
